<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                <td>Preço</td>
                <td>Vencimento</td>
                <td>Status</td>
                <td>Ação</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="venda in vendas" :key="venda.id">

                    <td>{{ parseFloat(venda.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</td>
                    <td>{{ moment(venda.vencimento).format('L') }}</td>
                    <td><span v-if="venda.status_id == 11" class="taxt-success">Pago</span> <span v-else-if="5" class="text-primary">Em aberto</span>
                        <span v-else class="text-danger">Cancelado</span>
                    </td>
                    <td>
                        <b-button target="_blank" variant="primary" :href="`https://cobrancaporboleto.com.br/geraBoleto.php?boleto=${venda.boleto_barato.url_fatura.split('=')[1]}`">Visualizar Boleto</b-button>
                    </td>
                </tr>


            </tbody>

        </table>
    </div>
</template>
<script>
export default {
    props: {
        vendas: Array
    }
}
</script>
